module.exports = __webpack_public_path__ + "img/eye-on.a70803ff.svg";